import { supabase } from '../lib/supabase';

class PsychologistService {
  /**
   * Get psychologist profile by user ID
   */
  async getPsychologistByUserId(userId) {
    try {
      
      const { data, error, count } = await supabase
        ?.from('psychologists')
        ?.select('*', { count: 'exact' })
        ?.eq('user_id', userId)
        ?.maybeSingle();

      if (error) throw error;

      return { data, error: null };
    } catch (error) {
      console.error('Get psychologist error:', error);
      return { data: null, error };
    }
  }

  /**
   * Get psychologist profile by ID
   */
  async getPsychologistById(id) {
    try {
      const { data, error } = await supabase
        ?.from('psychologists')
        ?.select('*')
        ?.eq('id', id)
        ?.maybeSingle();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Get psychologist by ID error:', error);
      return { data: null, error };
    }
  }

  /**
   * Update psychologist profile
   */
  async updatePsychologist(id, updates) {
    try {
      const { data, error } = await supabase
        ?.from('psychologists')
        ?.update(updates)
        ?.eq('id', id)
        ?.select()
        ?.single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Update psychologist error:', error);
      return { data: null, error };
    }
  }

  /**
   * Update psychologist profile by user ID
   */
  async updatePsychologistByUserId(userId, updates) {
    try {
      const { data, error } = await supabase
        ?.from('psychologists')
        ?.update(updates)
        ?.eq('id', userId)
        ?.select()
        ?.single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Update psychologist by user ID error:', error);
      return { data: null, error };
    }
  }

  /**
   * Upload profile photo
   */
  async uploadProfilePhoto(psychologistId, file) {
    try {
      const fileExt = file?.name?.split('.')?.pop();
      const fileName = `${psychologistId}-${Date.now()}.${fileExt}`;

      const { error: uploadError } = await supabase?.storage?.from('profile-photos')?.upload(fileName, file);

      if (uploadError) throw uploadError;

      const { data: { publicUrl } } = supabase?.storage?.from('profile-photos')?.getPublicUrl(fileName);

      return { url: publicUrl, error: null };
    } catch (error) {
      console.error('Upload profile photo error:', error);
      return { url: null, error };
    }
  }

  /**
   * Upload clinic logo
   */
  async uploadClinicLogo(psychologistId, file) {
    try {
      const fileExt = file?.name?.split('.')?.pop();
      const fileName = `${psychologistId}-logo-${Date.now()}.${fileExt}`;
      const { error: uploadError } = await supabase?.storage?.from('clinic-logos')?.upload(fileName, file);
      if (uploadError) throw uploadError;
      const { data: { publicUrl } } = supabase?.storage?.from('clinic-logos')?.getPublicUrl(fileName);

      return { url: publicUrl, error: null };
    } catch (error) {
      console.error('Upload clinic logo error:', error);
      return { url: null, error };
    }
  }

  /**
   * Get psychologist by public page slug
   */
  async getPsychologistBySlug(slug) {
    try {
      const { data, error } = await supabase
        ?.from('psychologists')
        ?.select('*')
        ?.eq('public_page_slug', slug)
        ?.eq('public_page_enabled', true)
        ?.maybeSingle();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Get psychologist by slug error:', error);
      return { data: null, error };
    }
  }
}

export const psychologistService = new PsychologistService();